<div class="modal--generic check-legal-guardian__modal">
  <h1 class="modal__header">Is the owner the insured's legal guardian?</h1>

  <div class="modal__actions modal__actions--inline">
    <button cpdsButton theme="mm-light" variant="secondary" class="check-legal-guardian__button" (click)="confirm()">
      Yes
    </button>
    <button cpdsButton theme="mm-light" variant="secondary" class="check-legal-guardian__button" (click)="cancel()">
      No
    </button>
  </div>
</div>
